import { LOCATION_STATE } from './constants'

const state = {
  [LOCATION_STATE]: {
    error: null,
    isFetching: false,
    data: {},
  },
}

export default state
